var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_178_181752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25294 15.5C3.09833 16.6963 4.97313 17.1073 6.44038 16.418C6.44138 16.4176 6.44234 16.4171 6.44335 16.4166L6.89814 16.2025C7.75666 16.8014 8.74348 17.2658 9.80892 17.5725V18C9.80892 19.3807 11.1817 20.5 12.8751 20.5C14.5684 20.5 15.9412 19.3807 15.9412 18V17.5725C17.0068 17.2654 17.9936 16.8004 18.852 16.2008L19.3088 16.4158C20.7764 17.1062 22.6526 16.6958 23.4992 15.4991C24.3459 14.3025 23.8426 12.7728 22.375 12.0825L21.9212 11.8691C22.1255 10.9629 22.1255 10.0338 21.9212 9.12746L22.375 8.91414C23.8426 8.22379 24.3459 6.6941 23.4992 5.49746C22.6526 4.30086 20.7765 3.89043 19.3088 4.58078L18.854 4.79496C17.9947 4.1968 17.0072 3.7332 15.9412 3.4275V3C15.9412 1.6193 14.5684 0.5 12.8751 0.5C11.1817 0.5 9.80892 1.6193 9.80892 3V3.4275C8.74334 3.73465 7.75647 4.19965 6.89814 4.79918L6.44129 4.58336C4.97366 3.89297 3.09756 4.3034 2.25088 5.5C1.40419 6.6966 1.90752 8.22633 3.37515 8.91668L3.82894 9.13C3.62465 10.0363 3.62465 10.9654 3.82894 11.8717L3.37515 12.085C1.91159 12.7772 1.40989 14.3039 2.25294 15.5ZM12.8751 7.16668C15.1329 7.16668 16.9632 8.65906 16.9632 10.5C16.9632 12.3409 15.1329 13.8333 12.8751 13.8333C10.6172 13.8333 8.78689 12.3409 8.78689 10.5C8.78689 8.65906 10.6172 7.16668 12.8751 7.16668Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_178_181752"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.5291,
    height: 20,
    fill: "white",
    transform: "translate(0.610352 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.635c45e645c74ee33f136f36136422ac.svg";
export { ForwardRef as ReactComponent };